<template>
  <component :is="BaseSingleTemplate" v-if="artist">
    <template #template-label>
      <Label :name="artist.artistType" />
    </template>
    <template #share-button>
      <ShareButton />
    </template>
    <template #main-image>
      <picture>
        <img
          :class="isArtistImageLoaded ? 'fade-in' : 'd-none'"
          :src="$router.options.imagePath + artist.mediaUrl"
          @load="isArtistImageLoaded = true"
        />
      </picture>
    </template>
    <template #data-info>
      <div class="data-info-container__header">
        <div
          class="data-info-container__header__item data-info-container__header__item--episode-left"
        >
          <div class="data-info-container__header__item__date">
            <router-link :to="setLocationArtistRoute(artist)">
              {{ artist.locationModel.locationname }}
            </router-link>
          </div>
          <h1 class="data-info-container__heading">
            {{ artist.name }}
          </h1>
        </div>
        <div
          v-if="artist.mainPodcast"
          class="data-info-container__header__item data-info-container__header__item--right-col"
        >
          <span>
            {{ getHeadingShows }}
          </span>
          <router-link
            v-for="show in podcasts"
            :key="show.id"
            :to="{ name: 'Podcasts', params: { id: show.permlink } }"
          >
            {{ show.name }}
          </router-link>
        </div>
      </div>
      <h4 class="data-info-container__subheading">
        {{ artist.artistType }} cv
      </h4>
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div class="data-info-container__content" v-html="artist.bio" />
      <div class="data-info-container__social">
        <template v-for="(social, key) in socialMediaModel">
          <div v-if="social"
               :key="key"
               class="data-info-container__social__item"
          >
            <a :href="social" target="_blank">
              {{ key }}
            </a>
          </div>
        </template>
        <div class="data-info-container__social__item">
          <ShareFacebook />
        </div>
      </div>
    </template>
    <template #episodes>
      <div class="episodes-container">
        <div class="episodes-container__inner">
          <div class="episodes-container__inner__header">
            <h4 class="episodes-single__heading">
              Episodes
            </h4>
            <BaseFilterEpisodes
              v-if="artist.artistType == 'Resident' && artist.podcasts.length >= 2"
              :shows="artist.podcasts"
              :selected-id.sync="selectedPodcastId"
            />
          </div>
          <div v-if="episodes.length" class="episodes-single__grid">
            <div v-for="episode in episodes"
                 :key="episode.id"
                 class="episodes-single__grid__item"
            >
              <EpisodeCard :episode="episode" :artist="artist" />
            </div>
            <div class="episodes-single__grid__item episodes-single__grid__item--empty " />
            <div class="episodes-single__grid__item episodes-single__grid__item--empty " />
            <div
              v-if="loading"
              class="episodes-single__grid__item episodes-single__grid__item--loader"
            >
              <Loading color="black" />
            </div>
            <div
              v-if="episodes.length && !loading && !pageLimit"
              class="episodes-single__grid episodes-single__grid--observer"
            >
              <IntersectionObserver :init-observer="initObserver" @intersect="loadEpisodes" />
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="episodes.length" #load-more>
      <div class="load-more">
        <div class="load-more__inner">
          <button
            v-if="!pageLimit"
            :disabled="loading"
            class="load-more__inner__button"
            @click="loadEpisodes"
          >
            <span>VIEW MORE EPISODES</span>
            <span>
              <img
                class="load-more__inner__icon"
                src="@/assets/icons/svg/arrow-down-icon-white.svg"
              />
            </span>
          </button>
          <span v-else>NO MORE EPISODES TO LOAD</span>
        </div>
      </div>
    </template>
    <template v-if="similarArtists.length" #related-section>
      <div class="related-section">
        <div class="related-section__header">
          <div class="related-section__header__title">
            similar artists
          </div>
          <router-link :to="{ name: 'Residents' }" class="related-section__header__link">
            view all
          </router-link>
        </div>
        <SimilarCarousel>
          <div v-for="similarartist in similarArtists"
               :key="similarartist.id"
               class="swiper-slide"
          >
            <SimilarArtistCard :resident="similarartist.similarArtist" />
          </div>
        </SimilarCarousel>
      </div>
    </template>
  </component>
</template>
<script>
import BaseSingleTemplate from '@/components/BaseSingleTemplate.vue';
import axios from 'axios';
import Label from '@/components/Label.vue';
import ShareButton from '@/components/ui/ShareButton.vue';
import EpisodeCard from '@/components/cards/EpisodeCard.vue';
import Loading from '@/components/ui/Loading.vue';
import IntersectionObserver from '@/components/ui/IntersectionObserver.vue';
import ShareFacebook from '@/components/ui/ShareFacebook.vue';
import SimilarArtistCard from '@/components/cards/SimilarArtistCard.vue';
import SimilarCarousel from '@/components/sections/SimilarCarousel.vue';
import BaseFilterEpisodes from '@/components/ui/BaseFilterEpisodes.vue';
export default {
  components: {
    Label,
    ShareButton,
    EpisodeCard,
    Loading,
    IntersectionObserver,
    ShareFacebook,
    SimilarArtistCard,
    BaseSingleTemplate,
    SimilarCarousel,
    BaseFilterEpisodes
  },
  data() {
    return {
      BaseSingleTemplate: BaseSingleTemplate,
      artist: null,
      similarArtists: [],
      episodes: [],
      size: 8,
      page: 0,
      totalPages: null,
      selectedPodcastId: 0,
      loading: false,
      podcasts: [],
      initObserver: false,
      isArtistImageLoaded: false,
      socialMediaModel: {},
      mainPodcastObject: {}
    };
  },

  computed: {
    pageLimit() {
      return this.page === this.totalPages - 1;
    },
    isArtistResident() {
      return this.artist.artistType === 'Resident';
    },
    initialPageSize() {
      return this.similarArtists.length > 0 ? 4 : 12;
    },
    getHeadingShows() {
      return this.podcasts.length >= 2 ? 'resident host on shows' : 'resident host on show';
    }
  },

  watch: {
    selectedPodcastId(id) {
      this.page = 0;
      this.episodes = [];
      if (id === 0) {
        this.getAllEpisodes();
      } else {
        this.getEpisodesByShowId();
      }
    }
  },

  created() {
    this.getArtist();
  },

  mounted() {
    let mql = window.matchMedia('(max-width: 1200px)');
    if (mql.matches) this.initObserver = true;
    return false;
  },

  methods: {
    setLocationArtistRoute(artist) {
      if(artist.artistType === 'Resident') {
        return {name: 'location-id-residents', params: {id: artist.locationModel.locationname}}
      } else {
        return {name: 'location-id-guests', params: {id: artist.locationModel.locationname}}
      }
    },
    getArtist() {
      axios
        .get(this.$router.options.api + '/artist/perm/' + this.$route.params.id)
        .then(response => {
          this.artist = response.data;
          this.socialMediaModel = {
            instagram: response.data.instagram,
            soundcloud: response.data.soundcloud,
            twitter: response.data.twitter,
            facebook: response.data.facebook,
            bandcamp: response.data.bandcamp
          };
          this.similarArtists = response.data.similarArtists;
          if (response.data.mainPodcast) {
            this.mainPodcastObject = this.artist.podcasts.find(podcast => {
              return podcast.id === response.data.mainPodcast;
            });
            this.podcasts = response.data.podcasts;
          }
          this.getAllEpisodes();
        })
        .catch(error => {
          console.error(error);
          this.errored = true;
        });
    },

    getEpisodesByShowId() {
      this.loading = true;
      axios
        .get(
          this.$router.options.api +
            `/episode/podcast/${this.selectedPodcastId}?size=${this.initialPageSize}&&page=${this.page}`
        )
        .then(response => {
          this.totalPages = response.data.totalPages;
          const apiData = response.data.content;
          this.episodes = [...this.episodes, ...apiData];
          this.loading = false;
        })
        .catch(e => {
          console.error(e.response);
        });
    },

    getAllEpisodes() {
      this.loading = true;
      axios
        .get(
          this.$router.options.api +
            `/episode/artist/${this.artist.id}?size=${this.initialPageSize}&&page=${this.page}`
        )
        .then(response => {
          this.totalPages = response.data.totalPages;
          const apiData = response.data.content;
          this.episodes = [...this.episodes, ...apiData];
          this.loading = false;
        })
        .catch(e => {
          console.error(e);
        });
    },

    loadEpisodes() {
      this.page++;
      this.scrollToPosition();
      if (this.selectedPodcastId === 0) {
        this.getAllEpisodes();
      } else {
        this.getEpisodesByShowId();
      }
    },

    scrollToPosition() {
      let mql = window.matchMedia('(max-width: 1200px)');
      if (mql.matches) return;
      setTimeout(() => {
        window.scrollBy({
          top: 900,
          left: 0,
          behavior: 'smooth'
        });
      }, 100);
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/assets/sass/pages/_artist-single.scss';
</style>
